import {useEffect, useState} from "react";
import ProductService from "../service/product";

const parseComma = (str) => {
    if (!str) return '';
    return str.replaceAll('|', ', ');
}

// const data11 = {
//     "success": true,
//     "productDetails": {
//         "Allergen_Type_Code_and_Containment_May_Contain_s": "אין",
//         "Allergen_Type_Code_and_Containment_s": "אין",
//         "Additional_Trade_Item_Description_1_t": "תפוציפס קראנצ' חטיף תפוח אדמה בטעם מקסיקני 50 גרם",
//         "Brand_Strauss_t": "תפוצ'יפס",
//         "Energy_per_100_grams_s": "539 קלוריות",
//         "Board_of_Supervision_t": "מועצה איזורית שדות נגב",
//         "Fats_per_100_grams_s": "33 גרם",
//         "Saturated_Fatty_Acids_per_100_grams_s": "3.4 גרם",
//         "Trans_Fatty_Acids_per_100_grams_s": "פחות מ-0.5 גרם",
//         "Cholesterol_per_100_grams_s": "0 מג",
//         "Diet_Information_t": "טבעוני|ללא גלוטן",
//         "Sodium_per_100_grams_s": "395 מג",
//         "Carbohydrates_per_100_grams_s": "54 גרם",
//         "Sugars_from_Carbohydrates_per_100_grams_s": "1.7 גרם",
//         "Proteins_per_100_grams_s": "6.1 גרם",
//         "Rabbinate_t": "בדצ העדה החרדית|בדצ ירושלים|כשר למהדרין",
//         "Nutritional_col_1_s": "ל-100 גרם",
//         "Ingredient_Sequence_and_Name_s": "תפוחי אדמה (62%), שמן צמחי, תערובת תיבול, סוכרים (אבקת סוכר, סוכר לבן, דקסטרוז), תערובת מלחים (מלח, אשלגן כלורי), מחזקי טעם (מונסודיום גלוטמט, E631, 627), חומרי טעם וריח, צבעי מאכל (אדום סלק, תמצית פפריקה).",
//         "Trade_Item_Description_GS1_t": "תפוצ'יפס קראנץ'  מקסיקני 50 גרם",
//         "packing_stick_forQRCode": "4252318",
//         "sku": "358476",
//         "Net_Weight_s": "50.000 גרם",
//         "BrandName_t": "עלית",
//         "lastModified": "2024-12-24T11:27:54+02:00",
//         "Kosher_Supervision_Type_s": "פרווה",
//         "kosher_for_passover_mark_s": "כשר לפסח ללא קטניות",
//         "rabbinate_passover_s": "חתם סופר בני ברק",
//         "Food_Symbol_Red_s": "ללא סימון",
//         "Carbohydrates_col2_s": "27 גרם",
//         "Cholesterol_col2_s": "0 מג",
//         "Energy_col2_s": "270 קלוריות",
//         "Fats_col2_s": "16.7 גרם",
//         "Nutritional_col_2_s": "למנה",
//         "Proteins_col2_s": "3.1 גרם",
//         "Saturated_Fatty_Acids_col2_s": "1.7 גרם",
//         "Sodium_col2_s": "198 מג",
//         "Sugars_from_Carbohydrates_col2_s": "0.8 גרם",
//         "Trans_Fatty_Acids_col2_s": "פחות מ-0.5 גרם",
//         "description_col2_s": "בשקית 50 גרם"
//     }
// }

const HomePage = () => {

    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [notFound, setNotFound] = useState(false);

    useEffect(() => {

        const urlParams = new URLSearchParams(window.location.search);
        const sku = urlParams.get('sku');

        const controller = new AbortController();
        const signal = controller.signal;
        // setData(data11.productDetails);
        // setLoading(false);

        if (sku) {
            ProductService.getProduct(sku, signal)
                .then((d) => {
                    if (d?.success) {
                        setData(d.productDetails);
                        setLoading(false);

                        window.document.title = `מוצר נגיש יותר ${d?.productDetails?.Brand_Strauss_t}`;

                    } else {

                        if (d?.errorCode === '404') {
                            setNotFound(true);
                            setLoading(false);

                            window.document.title = 'המוצר המבוקש לא נמצא';
                        } else {
                            setError(true);
                            setLoading(false);

                            window.document.title = 'התקלה בטיפול';
                        }
                    }
                })
                .catch((e) => {
                    setError(true);
                    setLoading(false);

                    window.document.title = 'התקלה בטיפול';
                });
        } else {
            setNotFound(true);
            setLoading(false);

            window.document.title = 'המוצר המבוקש לא נמצא';
        }

        return () => controller.abort;
    }, []);

    if(window.location.pathname === '/strauss-in'){
        console.log(123)
        return null;
    }

    if (loading) {
        return (
            <div className='loader'><img src='/loader.png' alt=''/></div>
        )
    }

    if (notFound) {
        return (
            <div>
                <section className='main error-main'>
                    <img className="qr-img" src={"/qr.jpg"} alt=""/>
                    <div className='error-wrapper'>
                        <h1 className='error-title'>אופס, אין אותי!</h1>
                    </div>
                    <div className='error-service'>
                        <p>
                            שירות הלקוחות שלנו זמין עבורך בטלפון <a href='tel:*6860'
                                                                    aria-label='לשירות לקוחות *6860 '>6860*</a> או ב- <a
                            href='https://wa.me/972527599753' aria-label='whatsapp' target='_blank'
                            rel='noreferrer'>WhatsApp </a><br className='only-desktop'/>
                            בנוסף, ניתן גם לשלוח לנו שאלות גם באמצעות <a
                            href='https://www.strauss-group.co.il/cs_form/%D7%98%D7%95%D7%A4%D7%A1-%D7%A6%D7%95%D7%A8-%D7%A7%D7%A9%D7%A8/#form_all_data_wrap'
                            target='_blank'
                            rel='noreferrer'>טופס צור קשר באתר שטראוס.</a>
                        </p>
                        <div className='links-section error-links'>
                            <a href='https://www.strauss-group.co.il/accessibility' target='_blank' rel='noreferrer'
                               aria-label='הצהרת נגישות נפתח באתר חיצוני'>הצהרת נגישות</a>
                            <a href='https://www.strauss-group.co.il/aboutus/privacy_policy' target='_blank'
                               rel='noreferrer' aria-label='מדיניות פרטיות נפתח באתר חיצוני'>מדיניות פרטיות</a>
                            <a href='https://www.strauss-group.co.il/terms_of_use' target='_blank' rel='noreferrer'
                               aria-label='תנאי שימוש נפתח באתר חיצוני'>תנאי שימוש</a>
                        </div>
                    </div>
                </section>
            </div>
        )
    }


    if (error) {
        return (
            <section className='main error-main'>
                <div className='error-wrapper'>
                    <h1 className='error-title'>מתנצלים,<br/>
                        כרגע לא ניתן לעבור לעמוד הרלוונטי.<br/>
                        התקלה בטיפול.</h1>
                </div>
                <div className='error-service'>
                    <p>
                        שירות הלקוחות שלנו זמין עבורך בטלפון <a href='tel:*6860'
                                                                aria-label='לשירות לקוחות *6860 '>6860*</a> או ב- <a
                        href='https://wa.me/972527599753' aria-label='whatsapp' target='_blank'
                        rel='noreferrer'>WhatsApp </a><br className='only-desktop'/>
                        בנוסף, ניתן גם לשלוח לנו שאלות גם באמצעות <a
                        href='https://www.strauss-group.co.il/cs_form/%D7%98%D7%95%D7%A4%D7%A1-%D7%A6%D7%95%D7%A8-%D7%A7%D7%A9%D7%A8/#form_all_data_wrap'
                        target='_blank'
                        rel='noreferrer'>טופס צור קשר באתר שטראוס.</a>
                    </p>
                    <div className='links-section error-links'>
                        <a href='https://www.strauss-group.co.il/accessibility' target='_blank' rel='noreferrer'
                           aria-label='הצהרת נגישות נפתח באתר חיצוני'>הצהרת נגישות</a>
                        <a href='https://www.strauss-group.co.il/aboutus/privacy_policy' target='_blank'
                           rel='noreferrer' aria-label='מדיניות פרטיות נפתח באתר חיצוני'>מדיניות פרטיות</a>
                        <a href='https://www.strauss-group.co.il/terms_of_use' target='_blank' rel='noreferrer'
                           aria-label='תנאי שימוש נפתח באתר חיצוני'>תנאי שימוש</a>
                    </div>
                </div>
            </section>
        )
    }

    return (
        <section className='main'>

            {showLogo(data?.Brand_Strauss_t)}

            <h1>{data?.Additional_Trade_Item_Description_1_t}</h1>

            {showOnePackageWeight(data?.Quantity_Of_Next_Lower_Level_Trade_Item_s, data?.Net_Weight_s)}

            <section className='p-section'>
                <h2>רכיבים</h2>
                <p>{data?.Ingredient_Sequence_and_Name_s}</p>
            </section>

            {showAllergens(data?.Allergen_Type_Code_and_Containment_s, data?.Allergen_Type_Code_and_Containment_May_Contain_s)}

            {showHazard(data?.Hazard_Precautionary_Statement_s)}

            <section className='p-section'>
                <h2>ערכים תזונתיים</h2>
                {showNutritionalValues(data)}
            </section>

            {showRedSticker(data?.Food_Symbol_Red_s)}

            {showKosher(data?.Rabbinate_t, data?.Board_of_Supervision_t, data?.Kosher_Supervision_Type_s, data?.rabbinate_passover_s, data?.kosher_for_passover_mark_s)}

            {showExtra(data?.Diet_Information_t)}

            {showCooking(data?.Serving_Suggestion_S)}

            <section className='p-section'>
                <h2>יש לך שאלה?</h2>
                <p>
                    שירות הלקוחות שלנו זמין עבורך בטלפון <a href='tel:*6860' target='_blank' rel='noreferrer'
                                                            aria-label='לשירות לקוחות *6860 '>6860*</a> או ב- <a
                    href='https://wa.me/972527599753' aria-label='whatsapp' target='_blank'
                    rel='noreferrer'>WhatsApp</a>
                </p>
                <p>
                    בנוסף, ניתן גם לשלוח לנו שאלות גם באמצעות <a
                    href='https://www.strauss-group.co.il/cs_form/%D7%98%D7%95%D7%A4%D7%A1-%D7%A6%D7%95%D7%A8-%D7%A7%D7%A9%D7%A8/#form_all_data_wrap'
                    target='_blank'
                    rel='noreferrer'>טופס צור קשר באתר שטראוס.</a>
                </p>
            </section>

            <section className='info-section p-section'>
                <p>בוצע בשיתוף עם מיזם "שווה פיתוח" ו"מרכז מגדל אור - יעדים לצפון",</p>
                <p>בדגש על התאמה לאנשים עם עיוורון ולקות ראיה, אשר לקחו חלק פעיל בתהליך הפיתוח.</p>
                <p>בכל מקרה של אי התאמה בין הכיתוב על האריזה, לכיתוב האלקטרוני, הכיתוב על האריזה גובר.</p>
                <div className='links-section'>
                    <a href='https://www.strauss-group.co.il/accessibility' target='_blank' rel='noreferrer'
                       aria-label='הצהרת נגישות נפתח באתר חיצוני'>הצהרת נגישות</a>
                    <a href='https://www.strauss-group.co.il/aboutus/privacy_policy' target='_blank' rel='noreferrer'
                       aria-label='מדיניות פרטיות נפתח באתר חיצוני'>מדיניות פרטיות</a>
                    <a href='https://www.strauss-group.co.il/terms_of_use' target='_blank' rel='noreferrer'
                       aria-label='תנאי שימוש נפתח באתר חיצוני'>תנאי שימוש</a>
                </div>
            </section>

        </section>
    );
}

export default HomePage;

const showLogo = (brand) => {

    switch (brand) {
        case 'דוריטוס' :
            return <img className='logo' src='./../DoritosLogo.svg' alt={`תמונה לוגו ${brand} שטראוס`}/>;
        case "צ'יטוס" :
            return <img className='logo' src='./../CheetosLogo.svg' alt={`תמונה לוגו ${brand} שטראוס`}/>;
        case "תפוצ'יפס" :
            return <img className='logo' src='./../TapuchipsLogo.svg' alt={`תמונה לוגו ${brand} שטראוס`}/>;
        default :
            return null;

    }

}

const showOnePackageWeight = (packageCount, netWeight) => {

    if (!packageCount) return null;

    const netWeightData = netWeight.split(' ');

    const str = netWeightData[1];
    const gram = Number(netWeightData[0]);
    const result = gram / Number(packageCount)
    if (result % 1 !== 0) return null;
    const text = `${result} ${str}`;

    return (
        <section className='p-section'>
            <h2>משקל פריט בודד</h2>
            <p>{text}</p>
        </section>
    )

}

const showHazard = (hazard) => {
    if (!hazard) return null;
    return (
        <section className='p-section'>
            <p>
                {hazard}
            </p>
        </section>
    )
}

const showNutritionalValues = (data) => {

    const keysData = {
        description_col1_s: {
            text: 'תיאור',
            order: 0,
            col2 : 'description_col2_s'
        },
        Energy_per_100_grams_s: {
            text: 'אנרגיה (קלוריות)',
            order: 1,
            col2 : 'Energy_col2_s'
        },
        Fats_per_100_grams_s: {
            text: 'שומנים (גרם)',
            order: 2,
            col2 : 'Fats_col2_s'
        },
        Saturated_Fatty_Acids_per_100_grams_s: {
            text: 'חומצות שומן רוויות (גרם)',
            order: 3,
            col2 : 'Saturated_Fatty_Acids_col2_s'
        },
        Unsaturated_Fatty_Acids_per_100_grams_s: {
            text: 'חומצות שומן בלתי רוויות (גרם)',
            order: 4,
            col2 : 'Unsaturated_Fatty_Acids_col2_s'
        },
        Trans_Fatty_Acids_per_100_grams_s: {
            text: 'חומצות שומן טראנס (גרם)',
            order: 5,
            col2 : 'Trans_Fatty_Acids_col2_s'
        },
        Cholesterol_per_100_grams_s: {
            text: 'כולסטרול (מ"ג)',
            order: 6,
            col2 : 'Cholesterol_col2_s'
        },
        Sodium_per_100_grams_s: {
            text: 'נתרן (מ"ג)',
            order: 7,
            col2 : 'Sodium_col2_s'
        },
        Carbohydrates_per_100_grams_s: {
            text: 'סך הפחמימות (גרם)',
            order: 8,
            col2 : 'Carbohydrates_col2_s'
        },
        Sugars_from_Carbohydrates_per_100_grams_s: {
            text: 'סוכרים מתוך פחמימות (גרם)',
            order: 9,
            col2 : 'Sugars_from_Carbohydrates_col2_s'
        },
        Sugar_Spoon_per_100_grams_s: {
            text: 'כפיות סוכר',
            order: 10,
            col2 : 'Sugar_Spoon_col2_s'
        },
        Dietary_Fibers_per_100_grams_s: {
            text: 'חלבונים (גרם)',
            order: 11,
            col2 : 'Dietary_Fibers_col2_s'
        },
        Proteins_per_100_grams_s: {
            text: 'חלבונים (גרם)',
            order: 12,
            col2 : 'Proteins_col2_s'
        },
        Added_Sugar_from_Sugars_per_100_grams_s: {
            text: 'מתוך סוכרים סוכר מוסף (גרם)',
            order: null,
            col2 : 'Added_Sugar_from_Sugars_col2_s'
        },
        Added_Sugar_Spoon_per_100_grams_s: {
            text: 'כפיות סוכר מוסף',
            order: null,
            col2 : 'Added_Sugar_Spoon_col2_s'
        },
        caffeine_per_100_grams_s: {
            text: 'קפאין (מ"ג)',
            order: null,
            col2 : 'caffeine_col2_s'
        },
        Calcium_per_100_grams_s: {
            text: 'סידן(מ"ג)',
            order: null,
            col2 : 'Calcium_col2_s'
        },
        Folic_Acid_per_100_grams_s: {
            text: 'חומצה פולית (מק"ג)',
            order: null,
            col2 : 'Folic_Acid_col2_s'
        },
        Iron_per_100_grams_s: {
            text: 'ברזל(מ"ג)',
            order: null,
            col2 : 'Iron_col2_s'
        },
        Lactose_from_Sugars_per_100_grams_s: {
            text: 'סוכרים מחלב ורכיביו (גרם)',
            order: null,
            col2 : 'Lactose_from_Sugars_col2_s'
        },
        Magnesium_per_100_grams_s: {
            text: 'מגנזיום(מ"ג)',
            order: null,
            col2 : 'Magnesium_col2_s'
        },
        Omega_3_per_100_grams_s: {
            text: 'אומגה 3(מ"ג)',
            order: null,
            col2 : 'Omega_3_col2_s'
        },
        Phosphorus_per_100_grams_s: {
            text: 'זרחן (מ"ג)',
            order: null,
            col2 : 'Phosphorus_col2_s'
        },
        Potassium_per_100_grams_s: {
            text: 'אשלגן (מ"ג)',
            order: null,
            col2 : 'Potassium_col2_s'
        },
        Sugar_Alcohols_per_100_grams_s: {
            text: 'רב כהלים(גרם)',
            order: null,
            col2 : 'Sugar_Alcohols_col2_s'
        },
        Vitamin_A_per_100_grams_s: {
            text: 'ויטמין A (מק"ג)',
            order: null,
            col2 : 'Vitamin_A_col2_s'
        },
        Vitamin_B1_per_100_grams_s: {
            text: 'ויטמין B1 (מ"ג)',
            order: null,
            col2 : 'Vitamin_B1_col2_s'
        },
        Vitamin_B12_per_100_grams_s: {
            text: 'ויטמין B12(מק"ג)',
            order: null,
            col2 : 'Vitamin_B12_col2_s'
        },
        Vitamin_B2_per_100_grams_s: {
            text: 'ויטמין B2 (מ"ג)',
            order: null,
            col2 : 'Vitamin_B2_col2_s'
        },
        Vitamin_B3_Niacin_per_100_grams_s: {
            text: 'ויטמין B3 ניאצין (מ"ג)',
            order: null,
            col2 : 'Vitamin_B3_Niacin_col2_s'
        },
        Vitamin_B3_Nicotinamide_per_100_grams_s: {
            text: 'ויטמין B3 ניקוטינאמיד (מ"ג)',
            order: null,
            col2 : 'Vitamin_B3_Nicotinamide_col2_s'
        },
        Vitamin_B5_per_100_grams_s: {
            text: 'ויטמין B5 (מ"ג)',
            order: null,
            col2 : 'Vitamin_B5_col2_s'
        },
        Vitamin_B6_per_100_grams_s: {
            text: 'ויטמין B6 (מ"ג)',
            order: null,
            col2 : 'Vitamin_B6_col2_s'
        },
        Vitamin_C_per_100_grams_s: {
            text: 'ויטמין C (מ"ג)',
            order: null,
            col2 : 'Vitamin_C_col2_s'
        },
        Vitamin_D_per_100_grams_s: {
            text: 'ויטמין D (מק"ג)',
            order: null,
            col2 : 'Vitamin_D_col2_s'
        },
        Vitamin_D3_per_100_grams_s: {
            text: 'ויטמין D3(מק"ג)',
            order: null,
            col2 : 'Vitamin_D3_col2_s'
        },
        Vitamin_E_per_100_grams_s: {
            text: 'ויטמין E(מ"ג)',
            order: null,
            col2 : 'Vitamin_E_col2_s'
        },
        Vitamin_K_per_100_grams_s: {
            text: 'ויטמין K(מק"ג)',
            order: null,
            col2 : 'Vitamin_K_col2_s'
        },
        Zinc_per_100_g_s: {
            text: 'אבץ (מ"ג)',
            order: null,
            col2 : 'Zinc_col2_s'
        },
        Acesulfame_K_per_100_grams_s: {
            text: 'אצסולפם k (מג)',
            order: null,
            col2 : 'Acesulfame_K_col2_s'
        },
        Aspartame_col2_s: {
            text: 'אספרטם (מג)',
            order: null,
            col2 : 'Aspartame_per_100_grams_s'
        },
        Monounsaturated_Fat_per_100_grams_s: {
            text: 'שומן חד בלתי רווי (גרם)',
            order: null,
            col2 : 'Monounsaturated_Fat_col2_s'
        },
        Polyunsaturated_Fat_per_100_grams_s: {
            text: 'שומן רב בלתי רווי (גרם)',
            order: null,
            col2 : 'Polyunsaturated_Fat_col2_s'
        },


    }

    return (
        <table>
            <thead>
            <tr>
                <th>סימון תזונתי</th>
                {
                    data?.Nutritional_col_1_s && <th>{data?.Nutritional_col_1_s}</th>
                }
                {
                    data?.Nutritional_col_2_s && <th>{data?.Nutritional_col_2_s}</th>
                }
            </tr>
            </thead>
            <tbody>
            {
                Object.keys(keysData).map((key, index) => {

                    const col2 = keysData[key].col2;
                    const col2Value = data[col2]

                    if (data.hasOwnProperty(key) && data[key]) {
                        return (
                            <tr key={index}>
                                <td>{keysData[key]?.text}</td>
                                <td>{data[key]}</td>
                                {col2Value && <td>{col2Value}</td>}
                            </tr>
                        )
                    } else {
                        return null;
                    }
                })
            }
            </tbody>
        </table>
    )
}
const showAllergens = (containing, mayContain) => {

    const showContaining = containing && containing !== 'אין' && containing !== 'מריק';
    const showMayContain = mayContain && mayContain !== 'אין' && mayContain !== 'מריק';

    if (showContaining || showMayContain) {
        return (
            <section className='p-section'>
                <h2>אלרגנים</h2>
                {
                    showContaining &&
                    <p>
                        <span>מכיל: </span>
                        {parseComma(containing)}
                    </p>
                }
                {
                    showMayContain &&
                    <p>
                        <span>עלול להכיל: </span>
                        {parseComma(mayContain)}
                    </p>
                }
            </section>
        )
    }

    return null;

}
const showKosher = (certificate1, certificate2, certificate3, certificate4, certificate5) => {
    const showCertificate1 = Boolean(certificate1);
    const showCertificate2 = Boolean(certificate2);
    const showCertificate3 = Boolean(certificate3);
    const showCertificate4 = Boolean(certificate4);
    const showCertificate5 = Boolean(certificate5);

    return (
        <section className='p-section'>
            <h2>כשרות{showCertificate3 && ` - ${parseComma(certificate3)}`}</h2>
            <p>
                {(showCertificate1 || showCertificate2) && <span><b> ימות השנה: </b></span>}
                {showCertificate1 && `${parseComma(certificate1)}`}
                {showCertificate1 && showCertificate2 && ', '}
                {showCertificate2 && `${parseComma(certificate2)}`}
            </p>
            {(showCertificate4 && showCertificate5) && <p>
                {(showCertificate4 || showCertificate2 || showCertificate5) && <span><b> פסח: </b></span>}
                {showCertificate4 && `${parseComma(certificate4)}`}
                {showCertificate4 && showCertificate5 && ', '}
                {showCertificate5 && `${parseComma(certificate5)}`}
                {showCertificate5 && showCertificate2 && ', '}
                {showCertificate2 && `${parseComma(certificate2)}`}
            </p>}
            <br/>
            <p>
                למידע בנוגע לכשרות המוצר בפסח יש לבדוק את הפרטים המופיעים בחזית האריזה בלבד
            </p>
        </section>
    )


}
const showExtra = (diet) => {

    const showDiet = Boolean(diet);

    return (
        <section className='p-section'>
            <h2>מידע נוסף על המוצר</h2>
            {showDiet && <p>{parseComma(diet)}</p>}
        </section>
    )
}

const showRedSticker = (foodRedSticker) => {

    const showSticker = Boolean(foodRedSticker) && foodRedSticker !== 'ללא סימון';

    return (
        <section className='p-section'>
            {showSticker && <p>  <b>מדבקה אדומה:</b> {parseComma(foodRedSticker)} </p>}
        </section>
    )
}

const showCooking = (cooking) => {

    if(!cooking) return null;

    return(
        <section className='p-section'>
            <h2>הוראות הכנה בישול ואפיה</h2>
            <p>{cooking}</p>
        </section>
    )

}